import { Controller } from '@hotwired/stimulus';
import TomSelect from 'tom-select';

// The permanent recipient picker loads a small contact list when it receives focus.
export default class extends Controller {
  static values = { url: String };

  connect() {
    this.select = new TomSelect(this.element, {
      valueField: 'id',
      labelField: 'name',
      searchField: ['name', 'email'],
      create: false,
      highlight: true,
      maxOptions: 15,
      preload: 'focus',
      load: (query, callback) => this.load(query, callback),
      render: {
        option: (item, escape) => `
          <div class="py-2">
            <div>${escape(item.name)}</div>
            <div class="small text-muted">${escape(item.email)}</div>
          </div>
        `,
      },
    });
  }

  disconnect() {
    if (this.select) this.select.destroy();
  }

  load(query, callback) {
    if (this.select.loading > 1) {
      callback();
      return;
    }

    fetch(`${this.urlValue}${encodeURIComponent(query || '')}`)
      .then((response) => response.json())
      .then((json) => callback(json))
      .catch(() => callback());
  }
}
